import WelcomeCallImporter from './WelcomeCallImporter'

export default WelcomeCallImporter
